package org.example.site_web.content

import org.example.site_web.to3d.A3DVertex


const val zPlane = 0.0
val accelargeBigTriangle: List<A3DVertex> = listOf(
    A3DVertex(57.0,-73.2,zPlane),
    A3DVertex(57.0,43.9,zPlane),
    A3DVertex(52.7,47.2,zPlane),
    A3DVertex(30.6,47.2,zPlane),
    A3DVertex(30.6,-6.0,zPlane),
    A3DVertex(-28.4,61.4,zPlane),
    A3DVertex(-57.8,61.4,zPlane)
)

val accelargeSmallTriangle = listOf (
    A3DVertex(15.3,36.1,zPlane),
    A3DVertex(15.3,79.2,zPlane),
    A3DVertex(-15.3,79.2,zPlane),
)

val accelargeTriangle = listOf (
    A3DVertex(0.0,0.0,0.0),
    A3DVertex(400.0,200.0,0.0),
    A3DVertex(400.0,-200.0,0.0),
)